import NewAccount from "@/views/profile/NewAccount";
import DontMeetRequirements from "@/views/profile/DontMeetRequirements/DontMeetRequirements";
import SwitchAccount from "@/views/profile/SwitchAccount";
import InvalidBooking from "@/views/profile/InvalidBooking/InvalidBooking";

export const profileRouter = [
  {
    path: "/profile",
    name: "profile",
    component: NewAccount
  },
  {
    path: "/dont-meet-requirements",
    name: "dontMeetRequirements",
    component: DontMeetRequirements
  },
  {
    path: "/switch-account",
    name: "switchAccount",
    component: SwitchAccount
  },
  {
    path: "/invalid-booking",
    name: "invalidBooking",
    component: InvalidBooking
  }
];
